import { render, staticRenderFns } from "./StartCom.vue?vue&type=template&id=4ad25fa4&scoped=true&"
import script from "./StartCom.vue?vue&type=script&lang=js&"
export * from "./StartCom.vue?vue&type=script&lang=js&"
import style0 from "./StartCom.vue?vue&type=style&index=0&id=4ad25fa4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ad25fa4",
  null
  
)

export default component.exports